export default __webpack_public_path__ + "static/media/star.60110675.svg";